// extracted by mini-css-extract-plugin
export default {"skeleton-select":"sNmsG","skeleton-select__wrapper":"C0qYL"};